import { Component } from '@angular/core'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import { CustomerPortalConfig } from '@inside-hub-app/customer-portal-config'
import { TransifexTranslatePipe } from '../../../../pipes/transifex-translate.pipe'
@Component({
  standalone: true,
  selector: 'customer-portal-app-impressum',
  templateUrl: './impressum.component.html',
  imports: [TransifexTranslatePipe]
})
export class ImpressumComponent {
  constructor(
    public remoteConfigService: EfRemoteConfigurationService<CustomerPortalConfig>
  ) {}
}
